import React, { useContext } from "react"

import { Button } from "~tailwindui/Basics"
import Modal from "~tailwindui/Modal"

import emptyFunction from "src/emptyFunction"

import CloudroomContext from "components/ChimeCloudroom/CloudroomContext"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"
import SupportModal from "components/SupportModal"

import ErrorModalContent from "./ErrorModalContent"

const ErrorModal = () => {
  const { session, localUser, error, clearError } = useContext(CloudroomContext)

  if (!error) return null
  const mayContinue =
    (error?.name === "MissingDevice" || error?.name === "DevicePermissions") &&
    error.message.toLowerCase().includes("camera") &&
    !session.studentCamerasRequired &&
    localUser.type === "Student"

  const title =
    error?.name === "MissingDevice"
      ? "Missing Device"
      : error?.name === "DevicePermissions"
      ? "Device Permissions Required"
      : "An Error Occurred"

  return localUser.type === "Student" || localUser.type === "Admin" ? (
    <ModalWithProvidedBody
      isOpen={!!error}
      hideTrigger
      hideCloseButton
      modalClassName="bootstrap-modal"
      modalTitle={title}
    >
      <>
        <ErrorModalContent
          error={error}
          mayContinue={mayContinue}
          userType={localUser.type}
        />
        <div className="modal-footer">
          <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
            {mayContinue ? (
              <button
                className="btn solid red btn-info mr-1"
                onClick={clearError}
              >
                Continue Without Camera
              </button>
            ) : (
              <button
                className="btn solid blue btn-info mr-1"
                onClick={() => window.location.reload()}
              >
                Refresh
              </button>
            )}
            {localUser.type === "Student" && (
              <SupportModal
                userType={localUser.type}
                error={error}
                phoneNumber={localUser.phoneNumber}
                sessionId={session.id}
              />
            )}
          </div>
        </div>
      </>
    </ModalWithProvidedBody>
  ) : (
    <Modal.Dialog hideButton isOpen={!!error} closeModal={emptyFunction}>
      <>
        <Modal.Header hideCloseButton>{title}</Modal.Header>
        <Modal.Body>
          <ErrorModalContent
            error={error}
            mayContinue={mayContinue}
            userType={localUser.type}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-between">
            <Button type="submit" onClick={() => window.location.reload()}>
              Refresh
            </Button>
            <SupportModal
              userType={localUser.type}
              error={error}
              phoneNumber={localUser.phoneNumber}
              sessionId={session.id}
            />
          </div>
        </Modal.Footer>
      </>
    </Modal.Dialog>
  )
}

export default ErrorModal
